import React from 'react';
import {
  StackedFillBarLabelContainer,
  StackedFillBarValueContainer,
  StyledHorizontalFillBar,
  HorizontalBarWrapper,
  HorizontalBarContainer,
  HorizontalBarFill,
  FillBarLabelContainer,
  StackedLabelValue,
  LabelName,
  LabelValue,
} from './styled';

export const FillBar = ({ label, value, fillPct, pctWidth, labelWidth, valueWidth }) => (
  <React.Fragment>
    <FillBarLabelContainer labelWidth={labelWidth}>
      <LabelName>{label}</LabelName>
    </FillBarLabelContainer>
    <HorizontalBarWrapper pctWidth={pctWidth}>
      <HorizontalBarContainer>
        <HorizontalBarFill fillPct={fillPct} />
      </HorizontalBarContainer>
    </HorizontalBarWrapper>
    <StackedFillBarValueContainer pctWidth={valueWidth}>
      <StackedLabelValue>{value}</StackedLabelValue>
    </StackedFillBarValueContainer>
  </React.Fragment>
);

export const StackedFillBar = ({ label, value, fillPct }) => (
  <React.Fragment>
    <StackedFillBarLabelContainer>
      <LabelName>{label}</LabelName>
      <LabelValue>{value}</LabelValue>
    </StackedFillBarLabelContainer>
    <HorizontalBarContainer>
      <HorizontalBarFill fillPct={fillPct} />
    </HorizontalBarContainer>
  </React.Fragment>
);

const HorizontalFillBar = (props) => {
  const { unit, label, value, fillPct, pctWidth, labelWidth, stacked, valueWidth } = props;

  return (
    <StyledHorizontalFillBar>
      {stacked ?
        <StackedFillBar
          label={label}
          value={value || props[unit]}
          fillPct={fillPct}
        />
        :
        <FillBar
          label={label}
          value={value || props[unit]}
          fillPct={fillPct}
          pctWidth={pctWidth}
          labelWidth={labelWidth}
          valueWidth={valueWidth}
        />}
    </StyledHorizontalFillBar>
  );
};

export default HorizontalFillBar;
